export default "__VITE_ASSET__4u1gI1Nq__"